import { coreMessages, type AppLocale } from './base-messages';

export const ar: AppLocale = {
  ...coreMessages,
  dataTable: {
    rowModeLabel: "عرض الصفوف",
    rowModeEllipsis: "اقتطاع (…) ",
    rowModeScroll: "سطر واحد مع تمرير أفقي",
    rowModeWrap: "التفاف الأسطر",
    columnsLabel: "الأعمدة",
    reorderColumnHint: "اسحب المقبض لنقل هذا العمود",
    resetThisTablePrefs: "إعادة ضبط هذا الجدول",
    resetThisTablePrefsTitle: "يمسح التخطيط المحفوظ لهذا الجدول فقط (وضع الصفوف والأعمدة والترتيب والعروض) دون تغيير إعدادات المستخدم العامة.",
    dataOperationsLabel: 'عمليات البيانات',
    operationExportExcel: 'تنزيل Excel',
    operationDownloadTemplate: 'تنزيل القالب',
    operationUploadTemplate: 'تحميل القالب',
    operationImportHistory: 'سجل التحميل',
    operationFieldDictionary: 'قاموس الحقول',
    operationUnsupported: 'هذا الجدول لا يدعم هذه العملية.',
    operationNoPermission: 'ليست لديك صلاحية لهذا الإجراء.',
    operationNotReady: 'هذا الإجراء غير جاهز بعد.',
    customFieldColumnsSectionLabel: 'الحقول المخصصة',
    importModalTitle: 'تحميل القالب',
    importChooseFile: 'اختر ملف CSV',
    importChooseFileHint: 'املأ القالب الذي تم تنزيله من هذا الجدول ثم ارفعه.',
    importNoFile: 'لم يتم اختيار ملف.',
    importSummary: 'ملخص الاستيراد',
    importReadyRows: 'الصفوف الجاهزة',
    importErrorRows: 'الصفوف التي تحتوي على أخطاء',
    importWarnings: 'تحذيرات',
    importUnknownHeaders: 'أعمدة غير معروفة',
    importMissingRequiredHeaders: 'أعمدة إلزامية مفقودة',
    importPreview: 'معاينة',
    importSubmit: 'بدء الاستيراد',
    importCancel: 'إلغاء',
    importParsing: 'جار قراءة الملف...',
    importSubmitting: 'جار الاستيراد...',
    importNoValidRows: 'لا توجد صفوف صالحة للاستيراد.',
    importFailed: 'فشل الاستيراد.',
    importSucceeded: 'اكتمل الاستيراد.',
    operationExportCsv: 'تنزيل CSV',
    operationExportPdf: 'تنزيل PDF',
    operationNoRows: 'لا توجد صفوف ظاهرة للتصدير.',
    importUnknownHeader: 'عمود غير معروف: {header}',
    importMissingRequiredHeader: 'عمود إلزامي مفقود: {header}',
    importRequiredCell: 'الحقل {header} مطلوب.',
    importMaxRowsExceeded: 'يحتوي الملف على أكثر من {maxRows} صف؛ تم تقييم أول {maxRows} صف فقط.',
    refreshLabel: 'تحديث',
    focusModeEnterLabel: 'التركيز على الجدول',
    focusModeFullscreenLabel: 'ملء الشاشة',
    focusModeExitLabel: 'إنهاء التركيز على الجدول',
    horizontalScrollLabel: 'تمرير أعمدة الجدول',
    selectionModeLabel: 'تحديد الصفوف',
    selectAllRowsLabel: 'تحديد كل الصفوف',
    selectRowLabel: 'تحديد الصف',
    bulkSelectedLabel: 'تم تحديد {count}',
    bulkActionsLabel: 'إجراءات مجمعة',
    tableSettingsLabel: 'إعدادات الجدول',
    appearanceSectionLabel: 'المظهر',
    columnsSectionLabel: 'الأعمدة',
    rowActionsLabel: 'إجراءات الصف',
  },
  passwordReset: {
    title: 'تعيين كلمة مرور جديدة',
    description: 'اختر كلمة مرور جديدة وقوية لا يعرفها سواك.',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    passwordHelp: 'استخدم 12 حرفًا على الأقل وثلاثة أنواع على الأقل من: أحرف صغيرة، أحرف كبيرة، أرقام، ورموز خاصة.',
    mismatch: 'كلمتا المرور غير متطابقتين.',
    invalidLink: 'رابط إعادة تعيين كلمة المرور مفقود أو غير صالح أو منتهي الصلاحية.',
    submit: 'تحديث كلمة المرور',
    submitting: 'جارٍ تحديث كلمة المرور...',
    success: 'تم تحديث كلمة المرور. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
    backToLogin: 'العودة إلى تسجيل الدخول',
    requestTitle: 'إرسال رابط إعادة تعيين كلمة المرور',
    requestDescription: 'سيتم إرسال رابط للاستخدام مرة واحدة صالح لمدة 30 دقيقة إلى البريد المسجل للمستخدم. تبقى كلمة المرور الحالية دون تغيير حتى استخدام الرابط.',
    requestSend: 'إرسال الرابط',
    requestSending: 'جارٍ الإرسال...',
    requestSuccess: 'تم قبول رابط إعادة تعيين كلمة المرور للإرسال.',
    requestError: 'تعذر إرسال رابط إعادة تعيين كلمة المرور.',
    selfServiceOpen: 'نسيت كلمة المرور',
    selfServiceTitle: 'نسيت كلمة المرور',
    selfServiceDescription: 'أدخل البريد الإلكتروني لحساب شركتك. إذا تطابق مع حساب، فسيتم إرسال رابط يستخدم مرة واحدة وصالح لمدة 30 دقيقة.',
    selfServiceEmailLabel: 'البريد الإلكتروني',
    selfServiceSubmit: 'طلب الرابط',
    selfServiceSubmitting: 'جارٍ إرسال الطلب...',
    selfServiceAcknowledgement: 'إذا كان هذا البريد مسجلاً، فسيتم إرسال رابط إعادة التعيين. يرجى التحقق من صندوق الوارد والبريد غير المرغوب فيه.',
    selfServiceClose: 'إغلاق',
    selfServiceCancel: 'إلغاء',
    selfServiceError: 'تعذر إكمال طلب إعادة التعيين حالياً. يرجى المحاولة لاحقاً.',
    selfServiceRateLimited: 'تم إرسال طلبات كثيرة. يرجى المحاولة لاحقاً.',
  },
  relationshipGraph: {
    sourceColumn: 'المصدر',
    relationshipColumn: 'العلاقة',
    targetColumn: 'السجل المرتبط',
    showDetails: 'إظهار التفاصيل',
    hideDetails: 'إخفاء التفاصيل',
    controlsLabel: 'عناصر التحكم بالخريطة',
    title: 'خريطة العلاقات',
    diagramLabel: 'علاقات السجل',
    diagramHelp: 'حدد بطاقة لفحص الروابط المسجلة.',
    detailsTitle: 'تفاصيل السجل',
    connectionsTitle: 'الروابط',
    noConnections: 'لا توجد روابط',
    loading: 'جارٍ تحميل العلاقات…',
    forbidden: 'ليست لديك صلاحية عرض هذه العلاقات.',
    error: 'تعذر تحميل العلاقات. أغلق الخريطة وحاول مجددًا.',
    empty: 'لا توجد روابط قابلة للعرض لهذا السجل.',
    invalid: 'تعذر التحقق من بيانات العلاقات. أغلق الخريطة وحاول مجددًا.',
    close: 'إغلاق خريطة العلاقات',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    fitView: 'ملاءمة الخريطة',
  },
  permissionPicker: {
    application: 'التطبيق',
    module: 'الوحدة',
    action: 'الإجراء',
    permissions: 'الأذونات',
    description: 'الوصف',
    selection: 'التحديد',
    sharedPermissions: 'الأذونات المشتركة',
    selectedPermissions: 'تم تحديد {count} من الأذونات',
    selectedOnly: 'المحدد فقط',
    unselectedOnly: 'غير المحدد فقط',
    selectedFirst: 'المحدد أولاً',
    noPermissions: 'لا توجد أذونات',
  },
  errors: {
    ...coreMessages.errors,
    unknown: 'حدث خطأ غير معروف',
    network: 'تعذر الاتصال بالخادم. يرجى التحقق من اتصال الإنترنت.',
    timeout: 'انتهت مهلة الطلب. يرجى المحاولة مرة أخرى.',
    badRequest: 'طلب غير صالح',
    unauthorized: 'انتهت جلستك. يرجى تسجيل الدخول مرة أخرى.',
    forbidden: 'ليس لديك صلاحية لهذا الإجراء.',
    notFound: 'المورد المطلوب غير موجود',
    tooManyRequests: 'تم إرسال طلبات كثيرة جداً. يرجى المحاولة لاحقاً.',
    internalServerError: 'حدث خطأ في الخادم. يرجى المحاولة لاحقاً.',
    badGateway: 'الخادم غير متاح مؤقتاً',
    serviceUnavailable: 'الخدمة غير متاحة مؤقتاً',
    gatewayTimeout: 'الخادم لا يستجيب',
    serverErrorWithStatus: 'خطأ في الخادم ({status})',
  },
  common: {
    databaseUnavailableDeveloperHint: 'ملاحظة للمطور: في التطوير المحلي يحدث هذا غالبا عند إيقاف VPN أو عدم السماح بعنوان IP الخاص بك. يرجى التحقق من VPN وصلاحية الوصول إلى قاعدة البيانات.',
    ...coreMessages.common,
    requestTimeout: 'The request timed out. Please try again.',
    backendConnectionErrorDev: 'تعذر الاتصال بخادم الواجهة الخلفية. يرجى التأكد من تشغيل الخادم ({apiUrl}).',
    backendConnectionErrorProd: 'تعذر الاتصال بخادم الواجهة الخلفية. يرجى المحاولة لاحقاً.',
    systemUpdating: 'جاري تحديث النظام...',
    serverConfiguring: 'جارٍ تكوين الخادم، يرجى الانتظار...',
    forbidden: 'Access denied.',
    network: 'Network error.',
    select: 'اختر',
    cancel: 'إلغاء',
    save: 'حفظ',
    saving: 'جار الحفظ...',
    edit: 'تعديل',
    view: 'عرض',
    copy: 'نسخ',
    delete: 'حذف',
    appLauncher: 'التطبيقات',
    allApps: 'جميع التطبيقات',
    loading: 'جار التحميل...',
    noData: 'لا توجد بيانات',
    code: 'الرمز',
    profileMenu: 'قائمة الملف الشخصي',
    selectLanguage: 'اختر اللغة',
    perPage: 'لكل صفحة',
    firstPage: 'الصفحة الأولى',
    previousPage: 'الصفحة السابقة',
    nextPage: 'الصفحة التالية',
    lastPage: 'الصفحة الأخيرة',
    pleaseWait: 'يرجى الانتظار',
    migrationDescription: 'جاري تطبيق تحديث قاعدة البيانات. قد تستغرق هذه العملية بضع ثوانٍ.',
    changeText: 'تغيير',
    deleteLogo: 'حذف الشعار',
    logoUploadHint: 'الحد الأقصى لحجم الملف: 5 ميجابايت. الصيغ المدعومة: JPEG، PNG، GIF، WebP',
    deleteAvatar: 'حذف الصورة الشخصية',
    avatarUploadHint: 'الحد الأقصى 5 ميجابايت. JPEG، PNG، GIF، WebP.',
    newRecord: 'سجل جديد',
    noPermission: 'ليس لديك صلاحية لهذا الإجراء',
    searchPlaceholder: 'بحث...',
    allStatuses: 'كل الحالات',
    active: 'نشط',
    inactive: 'غير نشط',
    clearFilters: 'مسح الفلاتر',
    all: 'الكل',
    clickToChangeStatus: 'انقر لتغيير الحالة',
    noChangePermission: 'ليس لديك إذن لتغيير الحالة',
    statusDistribution: 'توزيع الحالة',
    hide: 'إخفاء',
    show: 'إظهار',
    companies: 'Companies',
    adminConsole: 'وحدة التحكم الإدارية',
    manageAccount: 'إدارة حسابك',
    manageYourAccount: 'إدارة حسابك',
    notificationsTitle: 'الإشعارات',
    notificationsUnread: 'غير مقروء',
    notificationsTypesMuted: 'أنواع مكتومة',
    notificationsViewAll: 'عرض الكل',
    notificationsPreferences: 'التفضيلات',
    notificationsMutedLabel: 'مكتوم',
    notificationsEmpty: 'لا توجد إشعارات',
    selectAll: 'تحديد الكل',
    id: 'المعرّف',
    remove: 'إزالة',
    syncDeletedResult: 'تم حذف {count} إدخالات يتيمة.',
    distributionByTable: 'التوزيع حسب الجدول (السياق)',
    distributionByLocale: 'التوزيع حسب اللغة',
    translationReport: 'توزيع حالة الترجمة',
    page: 'صفحة',
    rows: 'صفوف',
    actions: 'إجراءات',
    create: 'إنشاء',
    search: 'بحث',
    closeSearch: 'إغلاق البحث',
    help: 'مساعدة',
    helpCenter: 'مركز المساعدة',
    helpAboutPage: 'حول هذه الصفحة',
    helpDocumentation: 'الوثائق',
    helpKeyboardShortcuts: 'اختصارات لوحة المفاتيح',
    helpWhatsNew: 'ما الجديد',
    helpF1Hint: 'اضغط F1 للحصول على مساعدة حول هذه الصفحة',
    helpNoDocsForPage: 'لا تتوفر وثائق لهذه الصفحة بعد',
    aiAssistantTitle: 'مساعد QubePro للذكاء الاصطناعي',
    aiAssistantButton: 'مساعد الذكاء الاصطناعي',
    aiAssistantUnavailable: 'مساعد الذكاء الاصطناعي غير متاح حاليًا.',
    appearancePreference: 'تفضيل المظهر',
    modalControlPlacement: 'موضع عناصر تحكم النموذج',
    modalControlPlacementHint: 'يحدد موضع عناصر الإغلاق وملء الشاشة في النماذج.',
    modalControlPlacementSystem: 'النظام (موصى به)',
    modalControlPlacementWindows: 'Windows',
    modalControlPlacementMacos: 'macOS',
    productTour: {
      start: 'بدء جولة المنتج',
      restart: 'إعادة تشغيل جولة المنتج',
      navigationTitle: 'القائمة الجانبية والوحدات',
      navigationDescription: 'استخدم القائمة الجانبية للوصول إلى الوحدات والصفحات المصرح بها وتوسيع كل قسم أو طيه.',
      appsTitle: 'التطبيقات',
      appsDescription: 'افتح تطبيقات QubePro وانتقل بينها من هنا.',
      profileTitle: 'الملف الشخصي والشركة',
      profileDescription: 'أدر ملفك الشخصي والشركة المحددة وتفضيلات اللغة من هنا.',
      aiTitle: 'QubePro AI',
      aiDescription: 'افتح مساعد QubePro للذكاء الاصطناعي للحصول على مساعدة مرتبطة بالصفحة الحالية.',
      helpTitle: 'مركز المساعدة',
      helpDescription: 'افتح الوثائق أو أعد تشغيل جولة المنتج في أي وقت.',
      next: 'التالي',
      previous: 'السابق',
      done: 'تم',
      close: 'إغلاق',
      neverShowAgain: 'عدم العرض تلقائياً مرة أخرى',
      progress: '{{current}} / {{total}}',
    },
    userExtensions: 'الإضافات',
    close: 'إغلاق',
    modalFocus: 'التركيز على النموذج',
    modalFullscreen: 'ملء الشاشة',
    modalRestore: 'استعادة الحجم',
    filterByColumn: 'تصفية حسب {column}',
    formCustomFieldsLoading: 'جارٍ تحميل الحقول المخصصة…',
    formCustomFieldsLoadError: 'تعذر تحميل الحقول المخصصة. أعد المحاولة قبل الحفظ لتجنب فقدان البيانات.',
    formCustomFieldsRetry: 'إعادة المحاولة',
    pageUnavailableTitle: 'تعذر فتح الصفحة',
    pageUnavailableMessage: 'يمكنك فتح صفحة أخرى من القائمة أو تحديث هذه الصفحة.',
    pageReloadWarning: 'يؤدي التحديث إلى فقدان التغييرات غير المحفوظة.',
    allTargetLanguages: 'جميع اللغات (10 لغات)',
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    errorOccurred: 'حدث خطأ',
    confirm: 'تأكيد',
    context: 'الجدول',
    key: 'العمود',
    originalShort: 'Orig.',
    originalValue: 'القيمة الأصلية',
    locale: 'اللغة',
    value: 'القيمة',
    status: 'الحالة',
    auto: 'تلقائي',
    manual: 'يدوي',
    manageLocales: 'إدارة اللغات',
    updateUntranslatedFields: 'مزامنة الحقول الجديدة',
    autoTranslate: 'ترجمة تلقائية',
    sourceAndTargetMustDiffer: 'يجب أن تختلف لغة المصدر والهدف.',
    autoTranslateSuccessCount: 'تمت ترجمة {count} عناصر تلقائياً.',
    syncEntriesResult: 'تمت مزامنة {count} إدخالات ترجمة جديدة.',
    translated: 'Translated',
    missing: 'مفقود',
    autoTranslateScope: 'نطاق الترجمة التلقائية',
    updateUntranslatedFieldsHint: 'انقر على "تحديث الحقول الجديدة" لمزامنة المحتوى من هذه الجداول.',
    processing: 'جاري المعالجة...',
    enterTargetLanguage: 'اختر اللغة المستهدفة.',
    sourceLanguage: 'لغة المصدر',
    selectLanguagesFirst: 'اختر اللغات من إدارة اللغات أولاً',
    sourceLanguageLabel: 'لغة المصدر (لغة الواجهة)',
    targetLanguage: 'اللغة المستهدفة',
    activeLocalesDescription: 'اختر اللغات النشطة. يتم الحفظ كإعدادات فقط.',
    selectSourceLanguageForSync: 'ما لغة المحتوى الحالي؟',
    languageNames: {
      en: 'الإنجليزية',
      tr: 'التركية',
      de: 'الألمانية',
      fr: 'الفرنسية',
      es: 'الإسبانية',
      ar: 'العربية',
      it: 'الإيطالية',
      ja: 'اليابانية',
      zh: 'الصينية',
      ru: 'الروسية',
    },
    warning: 'تحذير',
  },
  login: {
    ...coreMessages.login,
    loginFailed: 'فشل تسجيل الدخول',
    emailRequired: 'البريد الإلكتروني مطلوب',
    passwordRequired: 'كلمة المرور مطلوبة',
    backendUnavailable: 'الخادم غير متاح حاليًا. يرجى المحاولة لاحقًا.',
    backendConnectFailed: 'تعذر الاتصال بالخادم. يرجى المحاولة لاحقًا.',
    backendConnectFailedDev: 'تعذر الاتصال بالخادم. تأكد من تشغيل الخادم ({apiUrl}).',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholderFull: 'يرجى إدخال البريد الإلكتروني',
    passwordLabel: 'كلمة المرور',
    passwordPlaceholderFull: 'أدخل كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
    loggingIn: 'جار تسجيل الدخول...',
    submitButton: 'تسجيل الدخول',
    errors: {
      ...coreMessages.login.errors,
      invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى.',
      sessionTooLarge: 'بيانات الجلسة كبيرة جداً. يرجى تسجيل الدخول مرة أخرى.',
      databaseUnavailable: 'قاعدة البيانات غير متاحة أو يلزم الإعداد. يرجى تسجيل الدخول مرة أخرى.',
      accountInactive: 'حسابك غير نشط. يرجى الاتصال بمسؤول النظام.',
      sessionExpired: 'انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.',
      tooManyAttempts: 'محاولات كثيرة. يرجى المحاولة لاحقاً.',
    },
    featureTitle: "اربط سجلات العمليات والمالية",
    featureDescription: "تابع المخزون والمشتريات والمبيعات والسجلات المالية باستخدام QubePro ERP.",
    featureCard1Title: "المنتجات والمخزون",
    featureCard1Description: "أدر المنتجات والمستودعات وحركات المخزون.",
    featureCard2Title: "المشتريات",
    featureCard2Description: "تابع مستندات المشتريات والطلبات.",
    featureCard3Title: "مستندات المبيعات",
    featureCard3Description: "أدر طلبات المبيعات والفواتير.",
    featureCard4Title: "الحركات المالية",
    featureCard4Description: "راجع سجلات البنوك والصندوق والمالية.",
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    pleaseWait: 'يرجى الانتظار',
    serverConfiguring: 'جاري تكوين الخادم، يرجى الانتظار...',
    dbCreating: 'جاري إنشاء قاعدة البيانات والتكوينات المطلوبة. قد تستغرق هذه العملية بضع ثوانٍ.',
    loginPageTitle: 'تسجيل الدخول',
    languageToggleLabel: 'اختيار اللغة',
  },
  sidebar: {
    ...coreMessages.sidebar,
    dashboard: 'لوحة القيادة',
    settings: 'الإعدادات',
    toggleMenu: 'فتح القائمة',
    toggleMenuClose: 'إغلاق القائمة',
    companies: 'الشركات',
    logout: 'تسجيل الخروج',
    activityLogs: 'سجلات النشاط',
  },
  customFields: {
    title: 'الحقول المخصصة',
    newField: 'حقل مخصص جديد',
    editField: 'تعديل الحقل المخصص',
    entityType: 'نوع السجل',
    code: 'رمز الحقل',
    label: 'الاسم المعروض',
    codePlaceholder: 'مثال: riskLevel',
    labelPlaceholder: 'مثال: رمز خاص 1',
    dataType: 'نوع البيانات',
    type: 'النوع',
    scope: 'النطاق',
    companyId: 'معرّف الشركة',
    companySelection: 'الشركات',
    companySelectionPlaceholder: 'اتركه فارغًا ليكون عامًا، أو اختر شركات',
    selectedCompanies: '{{count}} شركات محددة',
    selectAllCompanies: 'تحديد كل الشركات',
    sortOrder: 'الترتيب',
    required: 'إلزامي',
    searchable: 'قابل للبحث',
    showInForm: 'إظهار في النموذج',
    showInList: 'إظهار العمود',
    formTab: 'تبويب النموذج',
    formTabSelect: 'تبويب النموذج',
    formTabPlaceholder: 'إذا كان فارغًا يستخدم تبويب الحقول المخصصة',
    defaultCustomTab: 'الحقول المخصصة',
    selectEntityTypeFirst: 'اختر نوع السجل أولًا',
    newFormTab: 'تبويب جديد',
    tabCode: 'رمز التبويب',
    tabName: 'اسم التبويب',
    tabCodePlaceholder: 'مثال: operations',
    tabNamePlaceholder: 'مثال: بيانات التشغيل',
    fieldWidth: 'تخطيط الصف',
    widthFull: 'حقل واحد في الصف',
    widthHalf: 'حقلان في الصف',
    widthThird: '3 حقول في الصف',
    widthQuarter: '4 حقول في الصف',
    systemField: 'حقل نظام',
    description: 'الوصف',
    options: 'الخيارات',
    optionsPlaceholder: 'كل سطر: الرمز:التسمية\nمثال: draft:مسودة\nأو اكتب مسودة فقط',
    defaultValue: 'القيمة الافتراضية',
    statusDistributionTitle: 'توزيع حالة {{title}}',
    emptyMessage: 'لم يتم تعريف أي حقول مخصصة بعد.',
    globalScope: 'عام',
    companyScope: 'الشركة {{id}}',
    deleteSelected: 'حذف المحدد',
    deleteSelectedMessage: 'سيتم حذف {{count}} حقول مخصصة. لا يمكن التراجع عن هذا الإجراء.',
    formDesigner: 'تصميم النموذج',
    formDesignerTitle: 'تصميم نموذج الحقول المخصصة',
    formDesignerEntityType: 'نوع السجل المراد تصميمه',
    formDesignerAllTabs: 'الكل',
    formDesignerEmpty: 'لا توجد حقول مخصصة لهذا النوع من السجلات.',
    formDesignerOriginalNotice: 'يتم الاحتفاظ بحقول النموذج الأصلية؛ تدير هذه الشاشة تبويبات الحقول المخصصة وترتيبها وتخطيط الصفوف.',
    formDesignerSave: 'حفظ التصميم',
    formDesignerSaved: 'تم حفظ تصميم النموذج.',
    formDesignerMoveUp: 'نقل لأعلى',
    formDesignerMoveDown: 'نقل لأسفل',
    formDesignerFieldSettings: 'تخطيط الحقل',
    formDesignerQuickSave: 'حفظ',
    formDesignerEditTab: 'تحرير التبويب',
    formDesignerDeleteTab: 'حذف التبويب',
    formDesignerTabEditorTitle: 'إعدادات التبويب',
    formDesignerCloseTabEditor: 'إغلاق محرر التبويب',
    dataTypes: {
      text: 'نص',
      number: 'رقم',
      date: 'تاريخ',
      datetime: 'تاريخ/وقت',
      boolean: 'نعم/لا',
      select: 'اختيار',
      json: 'JSON',
    },
  },
  activityLogs: {
    title: 'سجلات النشاط',
    searchPlaceholder: 'بحث (الكيان، الوحدة، الإجراء)…',
    allModules: 'كل الوحدات',
    allActions: 'كل الإجراءات',
    allSeverity: 'كل المستويات',
    allApps: 'كل التطبيقات',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    exportCsv: 'تصدير CSV',
    total: 'الإجمالي',
    today: 'اليوم',
    critical: 'حرج',
    warning: 'تحذير',
    severityInfo: 'معلومات',
    exportFilenameStem: 'activity-logs',
    noLogs: 'لم يُعثر على سجلات نشاط.',   system: 'النظام',
    field: 'الحقل',
    oldValue: 'القيمة السابقة',
    newValue: 'القيمة الجديدة',
    ip: 'IP',
    meta: 'بيانات وصفية للطلب',
    userAgent: 'User-Agent',
    entity: 'الكيان',
    severityCol: 'الشدة',
    userCol: 'المستخدم',
    actionCol: 'الإجراء',
    moduleCol: 'الوحدة',
    dateCol: 'التاريخ',
    appCol: 'التطبيق',
    overviewTitle: 'نظرة عامة',
    severityChart: 'توزيع الشدة',
    topModulesChart: 'أكبر الوحدات حسب الحجم',
    csvId: 'المعرّف',
    csvDate: 'التاريخ',
    csvUser: 'المستخدم',
    csvAction: 'الإجراء',
    csvModule: 'الوحدة',
    csvEntity: 'الكيان',
    csvSeverity: 'الشدة',
    csvIp: 'IP',
    csvApplication: 'التطبيق',
    companyCol: 'معرّف الشركة',
    allOutcomes: 'كل النتائج',
    noLogsDesc: 'ستظهر السجلات هنا عندما ينفذ المستخدمون إجراءات.',
    entityType: 'نوع السجل',
    actorType: 'نوع المنفذ',
    outcome: 'النتيجة',
    successful: 'ناجح',
    failed: 'فشل',
    denied: 'مرفوض',
    reason: 'السبب',
    requestId: 'معرّف الطلب',
    correlationId: 'معرّف الارتباط',
    integrity: 'دليل التكامل',
    outboxWarning: 'تتطلب قائمة انتظار تسليم التدقيق تدخلاً.',
  },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: 'الإشعارات',
    tabPreferences: 'التفضيلات',
    markAllRead: 'تحديد الكل كمقروء',
    notifCount: '{total} إشعارات',
    unreadCount: '{count} غير مقروءة',
    loading: 'جارٍ تحميل الإشعارات...',
    noNotifications: 'لا توجد إشعارات',    markRead: 'تحديد كمقروء',
    delete: 'حذف',   noPreferences: 'لا توجد تفضيلات',
    noPreferencesDesc: 'لم يتم العثور على فئات إشعارات بعد. يتم إنشاء التفضيلات تلقائياً عند استلام الإشعارات.',
    preferencesHeader: 'تفضيلات الإشعارات داخل التطبيق',
    prefItemDesc: 'تلقي إشعارات هذه الفئة داخل التطبيق',
    readDistribution: 'توزيع حالة القراءة',
    readStatusLabel: 'حالة القراءة',
    filterAll: 'الكل',
    filterUnread: 'غير مقروءة',
    filterRead: 'مقروءة',    colType: 'النوع',
    colTitle: 'العنوان',
    colMessage: 'الرسالة',
    colDate: 'التاريخ',
    colRead: 'الحالة',
    statusUnread: 'غير مقروء',
    statusRead: 'مقروء',
    searchNotifications: 'البحث في العنوان أو الرسالة…',
  },
};
